import React from "react";
import { Link } from "react-router-dom";
import { KTSVG } from "../../helpers/KTSVG";
import SvgIcon from "../../helpers/SvgIcon";

type Props = {
  className?: string;
  categories?:
    | {
        Icon?: JSX.Element;
        title?: string;
        subtitle?: string;
        value?: string | number;
        isIncreasing?: boolean;
        path?: string;
      }[]
    | null;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  MenuHeaderCategory?: JSX.Element;
};

const NavigationWrapper = ({ path, children }: any) => {
  if (path) {
    return (
      <Link
        to={path}
        className="group mb-4 flex min-w-0 items-center rounded-control no-underline transition-colors hover:bg-surface-hover">
        {children}
      </Link>
    );
  }
  return (
    <div className="mb-4 flex min-w-0 items-center rounded-control">
      {children}
    </div>
  );
};

const MenuCategory: React.FC<Props> = ({
  className = "",
  style,
  categories,
  children,
  MenuHeaderCategory,
}) => {
  return (
    <div
      className={`relative mx-3 mb-9 flex min-w-0 flex-col rounded-card bg-white shadow-xs ${className}`}
      style={style}>
      <div className="flex-auto p-0">
        {MenuHeaderCategory && MenuHeaderCategory}
        {categories && (
          <div
            className="relative z-[1] mx-9 mb-9 rounded-card bg-white px-6 py-9 shadow-xs"
            style={{ marginTop: MenuHeaderCategory ? -100 : 30 }}>
            {categories.map(
              ({ subtitle, title, value, isIncreasing, Icon, path }, index) => (
                <NavigationWrapper path={path} key={index}>
                  <div className="mr-4 flex h-[45px] w-[45px] shrink-0 items-center justify-center rounded-control bg-surface-subtle">
                    {Icon || (
                      <SvgIcon
                        type="BULLET_LINK"
                        fill="currentColor"
                        className="text-muted"
                        svgClassName="h-[22.75px] w-[22.75px]"
                      />
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="mb-0 text-[1.15rem] font-semibold text-[#3f4254] transition-colors group-hover:text-brand">
                      {title}
                    </p>
                    {subtitle && (
                      <p className="mb-0 mt-1 text-[0.95rem] font-medium text-muted">
                        {subtitle}
                      </p>
                    )}
                  </div>
                  {(value !== undefined || isIncreasing !== undefined) && (
                    <div className="flex shrink-0 items-center">
                      {value !== undefined && (
                        <span className="text-[1.25rem] font-semibold text-[#3f4254]">
                          {value}
                        </span>
                      )}
                      {isIncreasing !== undefined && (
                        <KTSVG
                          path={
                            isIncreasing
                              ? "/media/icons/duotune/arrows/arr066.svg"
                              : "/media/icons/duotune/arrows/arr065.svg"
                          }
                          className={
                            isIncreasing
                              ? "ml-1 [&_path]:!fill-success [&_rect]:!fill-success"
                              : "ml-1 [&_path]:!fill-danger [&_rect]:!fill-danger"
                          }
                          svgClassName="h-5 w-5"
                        />
                      )}
                    </div>
                  )}
                </NavigationWrapper>
              ),
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default MenuCategory;
